import { useAppSelector } from "../../store/hooks/hooks";
import Result from "../../components/common/Result";
import { getSecondWellIsOpen } from "../../store/slices/appSlice";
import { Trans, useTranslation } from "react-i18next";


const EMPTY_RESULTS = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

export const ResultsSection = () => {
	const { i18n, t } = useTranslation();
	const calculator = useAppSelector(state => state.vlpCalculator);
	const results1P = calculator?.well1?.results?.p ?? EMPTY_RESULTS;
	const results1Q = calculator?.well1?.results?.q ?? EMPTY_RESULTS;

	const results2P = calculator?.well2?.results?.p ?? EMPTY_RESULTS;
	const results2Q = calculator?.well2?.results?.q ?? EMPTY_RESULTS;

	const secondWell = useAppSelector(getSecondWellIsOpen);

	return (
		<fieldset className="vlp__result-block round-corner-container">
			<legend>{t("vlp:labels.results_title")}</legend>
			<div className="vlp__well1__results">
				<div className="vlp__well1__results_title"><span>{t(`vlp:labels.well1_title`)}</span></div>
				<div className="vlp__results_column_names">
					<div>
						<span>P </span>
						<span className="unit-font-size">
							<Trans
								ns={'vlp'}
								key={i18n.language}
								i18nKey={t(`common:measurement_units.pressure.bar`)}
								components={{
									sub: <sub />,
									sup: <sup />,
								}}
							/>
						</span>
					</div>
					<div>
						<span>Q </span>
						<span className="unit-font-size">
							<Trans
								ns={'vlp'}
								key={i18n.language}
								i18nKey={t(`common:measurement_units.q.thousand_m3_day`)}
								components={{
									sub: <sub />,
									sup: <sup />,
								}}
							/>
						</span>
					</div>
				</div>
				{results1P.map((result, i) => {
					return (<div className="vlp__result_row result-row" key={`ipr-well1-row-${i}`}>
						<Result
							className="vlp__result-value-p"
							id={`vlp-well1-p-${i}`}
							label={<></>}
							// unit={<>{t(`common:measurement_units.pressure.bar`)}</>}
							value={result.toString()}
						/>
						<Result
							className="vlp__result-value-q"
							id={`vlp-well1-q-${i}`}
							label={<></>}
							// unit={<>{t(`common:measurement_units.q.thousand_m3_day`)}</>}
							value={results1Q[i].toString()}
						/>
					</div>
					);
				})}
			</div>
			{secondWell &&
				<div className="vlp__well2__results">
					<div className="vlp__well2__results_title"><span>{t(`ipr:well2_title`)}</span></div>
					<div className="vlp__results_column_names">
						<div>
							<span>P </span>
							<span className="unit-font-size">
								<Trans
									ns={'vlp'}
									key={i18n.language}
									i18nKey={t(`common:measurement_units.pressure.bar`)}
									style={{ fontSize: '7px' }}
									components={{
										sub: <sub />,
										sup: <sup />,
									}}
								/>
							</span>
						</div>
						<div>
							<span>Q </span>
							<span className="unit-font-size">
								<Trans
									ns={'vlp'}
									key={i18n.language}
									i18nKey={t(`common:measurement_units.q.thousand_m3_day`)}
									style={{ fontSize: '7px' }}
									components={{
										sub: <sub />,
										sup: <sup />,
									}}
								/>
							</span>
						</div>
					</div>
					{results2P?.map((result, i) => {
						return (<div className="vlp__result_row result-row" key={`ipr-well2-row-${i}`}>
							<Result
								id={`vlp-well2-p-${i}`}
								label={<></>}
								// unit={<>{t(`common:measurement_units.pressure.bar`)}</>}
								value={result.toString()}
							/>
							<Result
								id={`vlp-well2-q-${i}`}
								label={<></>}
								// unit={<>{t(`common:measurement_units.q.thousand_m3_day`)}</>}
								value={results2Q[i].toString()}
							/>
						</div>);
					})}
				</div>
			}
		</fieldset>
	);
}